import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { BlockWrapper } from '../BlockWrapper.js';
import { Heading } from '../Heading/Heading.js';
export const ApplicationFormLayout = JSX((props) => {
    const { className, title, children, ...rest } = props;
    return (_jsx(BlockWrapper, { className: className, defaultPadding: "p-6xl", ...rest, children: _jsxs("div", { className: "container max-w-[978px] space-y-lg", children: [title ? _jsx(Heading, { headingType: "h3", title: title, className: "@xl:text-center" }) : null, children] }) }));
});
//# sourceMappingURL=ApplicationFormLayout.js.map